var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpotify = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 41.861 41.861"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "spotify_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h41.861v41.861H0z",
  "data-name": "Rectangle 7501"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 18868"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 18719"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#spotify_svg__a)",
  "data-name": "Group 18718"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.931 9.805a11.126 11.126 0 1 0 11.126 11.126A11.126 11.126 0 0 0 20.931 9.805m5.118 16.077a.66.66 0 0 1-.946.223c-2.615-1.614-5.9-1.947-9.791-1.057a.688.688 0 1 1-.334-1.335c4.228-.946 7.9-.557 10.792 1.223a.667.667 0 0 1 .279.946m1.335-3.06a.84.84 0 0 1-1.168.279 14.42 14.42 0 0 0-11.071-1.28.845.845 0 1 1-.5-1.613 16.28 16.28 0 0 1 12.518 1.5.786.786 0 0 1 .222 1.112m.111-3.115c-3.56-2.114-9.513-2.337-12.906-1.28a1.02 1.02 0 1 1-.612-1.947c3.95-1.168 10.459-.945 14.575 1.5a1.076 1.076 0 0 1 .39 1.447 1.17 1.17 0 0 1-1.447.278",
  "data-name": "Path 27261"
}))))));
export { SvgSpotify as ReactComponent };
export default __webpack_public_path__ + "static/media/spotify.31e56ac1c2567b542bedc5f4c6134f33.svg";